// The one place the three runtimes agree on how much to sample and where an
// event is filed. No session replay anywhere: the camera and guests' photos
// are exactly what the mobile app's Sentry deliberately never records, and the
// web guest camera is the same surface.
export const SENTRY_DSN =
  process.env.NEXT_PUBLIC_SENTRY_DSN || process.env.SENTRY_DSN || undefined;

export const SENTRY_ENVIRONMENT =
  process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT || process.env.NODE_ENV;

// Everything locally, a tenth of traffic in production — the same ratio the
// mobile app runs.
export const TRACES_SAMPLE_RATE =
  process.env.NODE_ENV === "development" ? 1.0 : 0.1;
